/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetAllAdnQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllAdnQuery = {
  __typename?: 'Query',
  allAdn?: Array<{
    __typename?: 'AdnDTO',
    identifier?: string | null,
    unNumber?: string | null,
    descriptionEN?: string | null,
    descriptionNL?: string | null,
    descriptionFR?: string | null
  }> | null
};

export type GetCargosForVoyagePlanQueryVariables = Types.Exact<{
  dischargingSearch: Types.CargoSearch;
  loadingSearch: Types.CargoSearch;
  pagination?: Types.InputMaybe<Types.Pagination>;
}>;


export type GetCargosForVoyagePlanQuery = {
  __typename?: 'Query',
  loadingCargos: {
    __typename?: 'CargoPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Cargo',
      id: number,
      containerNumber?: string | null,
      created?: number | null,
      empty?: boolean | null,
      transportType?: Types.TransportType | null,
      productDetails?: string | null,
      weight?: number | null,
      volume?: number | null,
      grossWeight?: number | null,
      tareWeight?: number | null,
      verifiedGrossWeight?: number | null,
      containerType?: {
        __typename?: 'ContainerType',
        isoTypeCode: string,
        displayCode?: string | null
      } | null,
      actions: Array<{
        __typename?: 'CargoAction',
        type: Types.CallType,
        weight?: number | null,
        volume?: number | null,
        call?: {
          __typename?: 'Call',
          id: number
        } | null,
        measurements: {
          __typename?: 'Measurements',
          locationWeight?: number | null,
          locationWeightUnit?: Types.WeightUnit | null,
          skipperWeight?: number | null,
          skipperWeightUnit?: Types.WeightUnit | null,
          locationVolume?: number | null,
          locationVolumeUnit?: Types.VolumeUnit | null,
          skipperVolume?: number | null,
          skipperVolumeUnit?: Types.VolumeUnit | null,
          ambientVolume?: number | null,
          relativeDensity?: number | null,
          productTemperature?: number | null,
          actualConsignor?: string | null,
          actualConsignee?: string | null,
          protest?: boolean | null
        }
      }>,
      product?: {
        __typename?: 'Product',
        id: number,
        name: string,
        description?: string | null
      } | null
    }>
  },
  dischargingCargos: {
    __typename?: 'CargoPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Cargo',
      id: number,
      containerNumber?: string | null,
      created?: number | null,
      empty?: boolean | null,
      transportType?: Types.TransportType | null,
      productDetails?: string | null,
      weight?: number | null,
      volume?: number | null,
      grossWeight?: number | null,
      tareWeight?: number | null,
      verifiedGrossWeight?: number | null,
      containerType?: {
        __typename?: 'ContainerType',
        isoTypeCode: string,
        displayCode?: string | null
      } | null,
      actions: Array<{
        __typename?: 'CargoAction',
        type: Types.CallType,
        weight?: number | null,
        volume?: number | null,
        call?: {
          __typename?: 'Call',
          id: number
        } | null,
        measurements: {
          __typename?: 'Measurements',
          locationWeight?: number | null,
          locationWeightUnit?: Types.WeightUnit | null,
          skipperWeight?: number | null,
          skipperWeightUnit?: Types.WeightUnit | null,
          locationVolume?: number | null,
          locationVolumeUnit?: Types.VolumeUnit | null,
          skipperVolume?: number | null,
          skipperVolumeUnit?: Types.VolumeUnit | null,
          ambientVolume?: number | null,
          relativeDensity?: number | null,
          productTemperature?: number | null,
          actualConsignor?: string | null,
          actualConsignee?: string | null,
          protest?: boolean | null
        }
      }>,
      product?: {
        __typename?: 'Product',
        id: number,
        name: string,
        description?: string | null
      } | null
    }>
  }
};

export type GetPreviousCargoesQueryVariables = Types.Exact<{
  shipId: Types.Scalars['Long']['input'];
  charterId?: Types.InputMaybe<Types.Scalars['Long']['input']>;
  pagination: Types.Pagination;
}>;


export type GetPreviousCargoesQuery = {
  __typename?: 'Query',
  previousCargoes: {
    __typename?: 'CargoPage',
    totalElements: number,
    content: Array<{
      __typename?: 'Cargo',
      id: number,
      cargoNumber?: string | null,
      charter?: {
        __typename?: 'SalesCharter',
        id: number,
        charterNumber: string,
        type: Types.CharterType
      } | null,
      product?: {
        __typename?: 'Product',
        name: string,
        previousCargoDisplayName?: string | null,
        id: number
      } | null,
      firstLoadingAction?: {
        __typename?: 'CargoAction',
        start?: number | null,
        end?: number | null,
        displayAsWindow?: boolean | null,
        simulatedTimestamp?: boolean | null
      } | null,
      actions: Array<{
        __typename?: 'CargoAction',
        type: Types.CallType,
        start?: number | null,
        call?: {
          __typename?: 'Call',
          atd?: number | null
        } | null
      }>,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null,
      tanks: Array<{
        __typename?: 'Tank',
        id: number
      }>
    }>
  }
};

export type GetCargoForSideviewerQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetCargoForSideviewerQuery = {
  __typename?: 'Query',
  cargo?: {
    __typename?: 'Cargo',
    id: number,
    containerNumber?: string | null,
    empty?: boolean | null,
    tareWeight?: number | null,
    weight?: number | null,
    grossWeight?: number | null,
    sealNumber?: string | null,
    product?: {
      __typename?: 'Product',
      id: number,
      code?: string | null,
      name: string,
      description?: string | null,
      densityKgM3?: number | null
    } | null,
    containerType?: {
      __typename?: 'ContainerType',
      isoTypeCode: string,
      displayCode?: string | null
    } | null,
    firstLoadingAction?: {
      __typename?: 'CargoAction',
      id: number,
      shipToShip?: boolean | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      connectingShipPortVisit?: {
        __typename?: 'ConnectingShipPortVisit',
        ship: {
          __typename?: 'Ship',
          id: number,
          name: string
        }
      } | null
    } | null,
    lastDischargingAction?: {
      __typename?: 'CargoAction',
      id: number,
      shipToShip?: boolean | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null,
      connectingShipPortVisit?: {
        __typename?: 'ConnectingShipPortVisit',
        ship: {
          __typename?: 'Ship',
          id: number,
          name: string
        }
      } | null
    } | null,
    actions: Array<{
      __typename?: 'CargoAction',
      id: number,
      type: Types.CallType,
      start?: number | null,
      end?: number | null,
      weight?: number | null,
      volume?: number | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string
      } | null
    }>,
    supplier?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    voyage?: {
      __typename?: 'Voyage',
      id: number,
      voyageNumber: string,
      lastShippedProductsFreeText: Array<string>,
      calls: Array<{
        __typename?: 'Call',
        id: number,
        actualStatusCode?: number | null,
        weight?: number | null,
        loadedWeight?: number | null,
        dischargedWeight?: number | null,
        mostAccurateArrivalTime?: number | null,
        mostAccurateDepartureTime?: number | null,
        callDischargingTeu?: number | null,
        callLoadingTeu?: number | null,
        createTwinCall: boolean,
        nrLoadingCargos: number,
        nrDischargingCargos: number,
        expectedLoadingAmount?: number | null,
        expectedLoadingTeu?: number | null,
        expectedDischargingAmount?: number | null,
        expectedDischargingTeu?: number | null,
        startPortChargeCountingTime?: number | null,
        startPortChargeCountingTimeOperator?: number | null,
        simulatedTimestamp: boolean,
        pta?: number | null,
        eta?: number | null,
        ata?: number | null,
        ptd?: number | null,
        etd?: number | null,
        atd?: number | null,
        etso?: number | null,
        eteo?: number | null,
        atso?: number | null,
        ateo?: number | null,
        etfm?: number | null,
        etlm?: number | null,
        atfm?: number | null,
        atlm?: number | null,
        atn?: number | null,
        dtn?: number | null,
        systemAta?: number | null,
        systemAtd?: number | null,
        systemEta?: number | null,
        systemEtd?: number | null,
        anglerCallInfo?: Array<{
          __typename?: 'AnglerCallInfo',
          skipperWeightMTon?: number | null,
          skipperVolumeL15?: number | null,
          locationWeightMTon?: number | null,
          locationVolumeL15?: number | null,
          type?: Types.CallType | null,
          volume?: number | null,
          weight?: number | null,
          product?: {
            __typename?: 'Product',
            id: number,
            code?: string | null,
            description?: string | null
          } | null
        } | null> | null,
        comments: Array<{
          __typename?: 'Comment',
          id: number,
          comment: string,
          created: number,
          createdBy: {
            __typename?: 'AccountDetails',
            id: number,
            username?: string | null,
            displayName?: string | null
          },
          label?: {
            __typename?: 'Label',
            id: number,
            type: Types.LabelType,
            text: string,
            color: string
          } | null
        }>,
        numberOfLoadingContainers?: {
          __typename?: 'NumberOfContainers',
          numEmptyLessThanOrEqualTo20ft: number,
          numEmptyFrom21ftThrough30ft: number,
          numEmptyFrom31ftThrough40ft: number,
          numEmptyGreaterThan40ft: number,
          numFullLessThanOrEqualTo20ft: number,
          numFullFrom21ftThrough30ft: number,
          numFullFrom31ftThrough40ft: number,
          numFullGreaterThan40ft: number,
          numLessThanOrEqualTo20ft: number,
          numFrom21ftThrough30ft: number,
          numFrom31ftThrough40ft: number,
          numGreaterThan40ft: number,
          totalTeu: number,
          numTotalFullContainers: number,
          numTotalEmptyContainers: number,
          numTotalContainers: number
        } | null,
        numberOfDischargingContainers?: {
          __typename?: 'NumberOfContainers',
          numEmptyLessThanOrEqualTo20ft: number,
          numEmptyFrom21ftThrough30ft: number,
          numEmptyFrom31ftThrough40ft: number,
          numEmptyGreaterThan40ft: number,
          numFullLessThanOrEqualTo20ft: number,
          numFullFrom21ftThrough30ft: number,
          numFullFrom31ftThrough40ft: number,
          numFullGreaterThan40ft: number,
          numLessThanOrEqualTo20ft: number,
          numFrom21ftThrough30ft: number,
          numFrom31ftThrough40ft: number,
          numGreaterThan40ft: number,
          totalTeu: number,
          numTotalFullContainers: number,
          numTotalEmptyContainers: number,
          numTotalContainers: number
        } | null,
        numberOfLoadingReeferContainers?: {
          __typename?: 'NumberOfContainers',
          numEmptyLessThanOrEqualTo20ft: number,
          numEmptyFrom21ftThrough30ft: number,
          numEmptyFrom31ftThrough40ft: number,
          numEmptyGreaterThan40ft: number,
          numFullLessThanOrEqualTo20ft: number,
          numFullFrom21ftThrough30ft: number,
          numFullFrom31ftThrough40ft: number,
          numFullGreaterThan40ft: number,
          numLessThanOrEqualTo20ft: number,
          numFrom21ftThrough30ft: number,
          numFrom31ftThrough40ft: number,
          numGreaterThan40ft: number,
          totalTeu: number,
          numTotalFullContainers: number,
          numTotalEmptyContainers: number,
          numTotalContainers: number
        } | null,
        numberOfDischargingReeferContainers?: {
          __typename?: 'NumberOfContainers',
          numEmptyLessThanOrEqualTo20ft: number,
          numEmptyFrom21ftThrough30ft: number,
          numEmptyFrom31ftThrough40ft: number,
          numEmptyGreaterThan40ft: number,
          numFullLessThanOrEqualTo20ft: number,
          numFullFrom21ftThrough30ft: number,
          numFullFrom31ftThrough40ft: number,
          numFullGreaterThan40ft: number,
          numLessThanOrEqualTo20ft: number,
          numFrom21ftThrough30ft: number,
          numFrom31ftThrough40ft: number,
          numGreaterThan40ft: number,
          totalTeu: number,
          numTotalFullContainers: number,
          numTotalEmptyContainers: number,
          numTotalContainers: number
        } | null,
        dischargingCargos: Array<{
          __typename?: 'Cargo',
          cargoNumber?: string | null,
          id: number,
          totalLoadingWeight?: number | null,
          totalDischargingWeight?: number | null,
          product?: {
            __typename?: 'Product',
            id: number,
            name: string,
            code?: string | null
          } | null,
          containerType?: {
            __typename?: 'ContainerType',
            lengthFt?: number | null,
            teu: number
          } | null,
          containerGroup?: {
            __typename?: 'ContainerGroup',
            lengthFt?: number | null,
            teu?: number | null
          } | null
        }>,
        loadingCargos: Array<{
          __typename?: 'Cargo',
          cargoNumber?: string | null,
          id: number,
          totalLoadingWeight?: number | null,
          totalDischargingWeight?: number | null,
          product?: {
            __typename?: 'Product',
            id: number,
            name: string,
            code?: string | null
          } | null,
          containerType?: {
            __typename?: 'ContainerType',
            lengthFt?: number | null,
            teu: number
          } | null,
          containerGroup?: {
            __typename?: 'ContainerGroup',
            lengthFt?: number | null,
            teu?: number | null
          } | null
        }>,
        cargos: Array<{
          __typename?: 'CargoAction',
          id: number,
          type: Types.CallType,
          start?: number | null,
          cargo: {
            __typename?: 'Cargo',
            id: number,
            cargoNumber?: string | null,
            product?: {
              __typename?: 'Product',
              id: number,
              name: string
            } | null
          }
        }>,
        location: {
          __typename?: 'Location',
          id: number,
          description: string,
          code?: string | null,
          type: Types.LocationType,
          abbreviation?: string | null,
          address?: {
            __typename?: 'Address',
            zipCode?: string | null,
            town?: string | null
          } | null,
          locationGroups: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          }>
        },
        voyage: {
          __typename?: 'Voyage',
          id: number,
          voyageNumber: string,
          allSuppliersConfigured?: boolean | null,
          lastShippedProductsFreeText: Array<string>,
          isBallast: boolean,
          lastStatusChange?: {
            __typename?: 'StatusChange',
            id: number,
            actualTime?: number | null,
            actualTimeOriginal?: number | null,
            actualTimeOverride?: number | null,
            estimateTime?: number | null,
            comment?: string | null,
            skipperComment?: string | null,
            timestamp?: number | null,
            appliedBy?: string | null,
            deletable: boolean,
            communicatedToCustomer?: number | null,
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }>,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null
            },
            supplier?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            origin?: {
              __typename?: 'StatusChange',
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }
            } | null
          } | null,
          documents?: Array<{
            __typename?: 'Document',
            id: number,
            created?: number | null,
            issuedAt?: string | null,
            active?: boolean | null,
            description?: string | null,
            documentEntity: Types.DocumentEntity,
            filename?: string | null,
            type: string,
            documentType?: string | null,
            validUntil?: number | null,
            status: Types.DocumentStatus,
            lastStatusUpdateOn: number,
            cargoActionId?: number | null,
            cargo?: {
              __typename?: 'CargoLinkDTO',
              id: number,
              cargoNumber?: string | null,
              containerNumber?: string | null,
              product: {
                __typename?: 'CargoLinkProductDTO',
                id: number,
                name: string,
                description?: string | null
              }
            } | null,
            voyage?: {
              __typename?: 'VoyageLinkDTO',
              id: number,
              voyageNumber: string,
              inactivityType?: Types.InactivityType | null,
              ship: {
                __typename?: 'VoyageLinkShipDTO',
                id: number
              }
            } | null,
            charter?: {
              __typename?: 'CharterLinkDTO',
              id: number,
              charterNumber: string,
              type: Types.CharterType
            } | null
          } | null> | null,
          creditor?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          cargos: Array<{
            __typename?: 'Cargo',
            id: number,
            cargoNumber?: string | null,
            firstLoadingAction?: {
              __typename?: 'CargoAction',
              id: number,
              start?: number | null
            } | null,
            lastDischargingAction?: {
              __typename?: 'CargoAction',
              id: number,
              end?: number | null
            } | null,
            product?: {
              __typename?: 'Product',
              id: number,
              name: string
            } | null,
            comments: Array<{
              __typename?: 'Comment',
              id: number,
              comment: string,
              created: number,
              createdBy: {
                __typename?: 'AccountDetails',
                id: number,
                username?: string | null,
                displayName?: string | null
              },
              label?: {
                __typename?: 'Label',
                id: number,
                type: Types.LabelType,
                text: string,
                color: string
              } | null
            }>,
            statusChanges: Array<{
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            }>,
            lastStatusChange?: {
              __typename?: 'StatusChange',
              id: number,
              actualTime?: number | null,
              actualTimeOriginal?: number | null,
              actualTimeOverride?: number | null,
              estimateTime?: number | null,
              comment?: string | null,
              skipperComment?: string | null,
              timestamp?: number | null,
              appliedBy?: string | null,
              deletable: boolean,
              communicatedToCustomer?: number | null,
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }>,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null
              },
              supplier?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null,
              origin?: {
                __typename?: 'StatusChange',
                status: {
                  __typename?: 'Status',
                  id: number,
                  description: string,
                  type: Types.StatusType,
                  cargoActionType?: Types.CallType | null,
                  color: string,
                  statusOrder?: number | null,
                  supplierRequired: boolean,
                  skipperRequiredFillInSailingReport: boolean,
                  skipperRequiredFillInWeightVolume: boolean,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean,
                  requireActualTime: Types.StatusActualTimeType,
                  estimateType?: Types.StatusEstimateType | null,
                  estimateRequirement: Types.StatusEstimateRequirement,
                  shouldLoadOnTerminal: boolean,
                  closedStatus: boolean,
                  cancelledStatus: boolean,
                  loadedStatus: boolean,
                  dischargedStatus: boolean,
                  finishedStatus: boolean,
                  allowComment: boolean,
                  allowSkipperComment: boolean,
                  shouldUpdateJDE: boolean,
                  isInProgress: boolean,
                  voyageVisibleBySkipper: boolean,
                  voyageVisibleByCreditor: boolean,
                  voyageEditableBySkipper: boolean,
                  voyageEditableByCreditor: boolean,
                  callVisibleByLocationOwner: boolean,
                  isRejectStatus: boolean,
                  isAcceptStatus: boolean,
                  notifySkippers: boolean,
                  notifyShipManagers: boolean,
                  notifyShipOwners: boolean,
                  notifyOperators: boolean,
                  notifyCustomers: boolean,
                  notifyTerminals: boolean,
                  isCustomerNominatingStatus: boolean,
                  isSkipperNominatingStatus: boolean,
                  includeInNominationExport: boolean,
                  laytimeStartStatus: boolean,
                  laytimeEndStatus: boolean,
                  requireDocuments: boolean,
                  showConfirmMessage: boolean,
                  expiringStatus: boolean,
                  isActionStatus: boolean,
                  requireTanks: boolean,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean,
                    type?: Types.SendDocumentType | null,
                    target?: Types.DocumentTarget | null
                  } | null,
                  translations?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  confirmMessages?: {
                    __typename?: 'LanguageDescription',
                    id: number,
                    defaultValue?: string | null,
                    descriptions: Array<{
                      __typename?: 'TranslationKeyValuePair',
                      key: string,
                      value: string
                    }>
                  } | null,
                  rules?: Array<{
                    __typename?: 'Rule',
                    id: number,
                    ifFitsStatusFlow: boolean,
                    ifNotAppliedBefore: boolean,
                    ruleType: {
                      __typename?: 'RuleType',
                      name: Types.StatusRule
                    },
                    targetStatus: {
                      __typename?: 'Status',
                      id: number,
                      type: Types.StatusType,
                      supplierRequired: boolean,
                      description: string,
                      sendDocument?: {
                        __typename?: 'SendDocumentStatus',
                        enabled: boolean
                      } | null
                    }
                  }> | null,
                  successiveStatuses: Array<{
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    description: string,
                    applyByCustomer: boolean,
                    applyBySkipper: boolean,
                    applyByTerminal: boolean
                  }>
                }
              } | null
            } | null
          }>,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string,
            bargeType?: Types.BargeType | null,
            defaultCharterSubtype?: Types.CharterSubtype | null,
            tanks: Array<{
              __typename?: 'Tank',
              id: number,
              position: Types.TankPosition,
              positionNumber: number,
              capacityM3?: number | null
            }>
          },
          purchaseCharters?: Array<{
            __typename?: 'PurchaseCharter',
            id: number,
            type: Types.CharterType
          }> | null,
          statusChanges: Array<{
            __typename?: 'StatusChange',
            id: number,
            actualTime?: number | null,
            actualTimeOriginal?: number | null,
            actualTimeOverride?: number | null,
            estimateTime?: number | null,
            comment?: string | null,
            skipperComment?: string | null,
            timestamp?: number | null,
            appliedBy?: string | null,
            deletable: boolean,
            communicatedToCustomer?: number | null,
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }>,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null
            },
            supplier?: {
              __typename?: 'Relation',
              id: number,
              name: string
            } | null,
            origin?: {
              __typename?: 'StatusChange',
              status: {
                __typename?: 'Status',
                id: number,
                description: string,
                type: Types.StatusType,
                cargoActionType?: Types.CallType | null,
                color: string,
                statusOrder?: number | null,
                supplierRequired: boolean,
                skipperRequiredFillInSailingReport: boolean,
                skipperRequiredFillInWeightVolume: boolean,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean,
                requireActualTime: Types.StatusActualTimeType,
                estimateType?: Types.StatusEstimateType | null,
                estimateRequirement: Types.StatusEstimateRequirement,
                shouldLoadOnTerminal: boolean,
                closedStatus: boolean,
                cancelledStatus: boolean,
                loadedStatus: boolean,
                dischargedStatus: boolean,
                finishedStatus: boolean,
                allowComment: boolean,
                allowSkipperComment: boolean,
                shouldUpdateJDE: boolean,
                isInProgress: boolean,
                voyageVisibleBySkipper: boolean,
                voyageVisibleByCreditor: boolean,
                voyageEditableBySkipper: boolean,
                voyageEditableByCreditor: boolean,
                callVisibleByLocationOwner: boolean,
                isRejectStatus: boolean,
                isAcceptStatus: boolean,
                notifySkippers: boolean,
                notifyShipManagers: boolean,
                notifyShipOwners: boolean,
                notifyOperators: boolean,
                notifyCustomers: boolean,
                notifyTerminals: boolean,
                isCustomerNominatingStatus: boolean,
                isSkipperNominatingStatus: boolean,
                includeInNominationExport: boolean,
                laytimeStartStatus: boolean,
                laytimeEndStatus: boolean,
                requireDocuments: boolean,
                showConfirmMessage: boolean,
                expiringStatus: boolean,
                isActionStatus: boolean,
                requireTanks: boolean,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean,
                  type?: Types.SendDocumentType | null,
                  target?: Types.DocumentTarget | null
                } | null,
                translations?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                confirmMessages?: {
                  __typename?: 'LanguageDescription',
                  id: number,
                  defaultValue?: string | null,
                  descriptions: Array<{
                    __typename?: 'TranslationKeyValuePair',
                    key: string,
                    value: string
                  }>
                } | null,
                rules?: Array<{
                  __typename?: 'Rule',
                  id: number,
                  ifFitsStatusFlow: boolean,
                  ifNotAppliedBefore: boolean,
                  ruleType: {
                    __typename?: 'RuleType',
                    name: Types.StatusRule
                  },
                  targetStatus: {
                    __typename?: 'Status',
                    id: number,
                    type: Types.StatusType,
                    supplierRequired: boolean,
                    description: string,
                    sendDocument?: {
                      __typename?: 'SendDocumentStatus',
                      enabled: boolean
                    } | null
                  }
                }> | null,
                successiveStatuses: Array<{
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  description: string,
                  applyByCustomer: boolean,
                  applyBySkipper: boolean,
                  applyByTerminal: boolean
                }>
              }
            } | null
          }>,
          lastShippedProducts?: Array<{
            __typename?: 'Product',
            id: number,
            code?: string | null,
            description?: string | null,
            name: string,
            densityKgM3?: number | null,
            adnGood?: {
              __typename?: 'ProductADNGood',
              id: number,
              unNumber?: number | null,
              descriptionDE?: string | null,
              descriptionEN?: string | null,
              descriptionNL?: string | null
            } | null,
            nstrGood?: {
              __typename?: 'ProductNSTRGood',
              id: number,
              nstrCode?: number | null,
              cargoGroup?: string | null
            } | null,
            idtfGood?: {
              __typename?: 'ProductIDTFGood',
              id: number,
              idtfNumber?: number | null,
              productName?: string | null
            } | null
          }> | null,
          from?: {
            __typename?: 'Location',
            id: number,
            type: Types.LocationType,
            description: string
          } | null,
          to?: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          } | null,
          calls: Array<{
            __typename?: 'Call',
            id: number,
            actualStatusCode?: number | null,
            pta?: number | null,
            eta?: number | null,
            ata?: number | null,
            ptd?: number | null,
            etd?: number | null,
            atd?: number | null,
            etso?: number | null,
            eteo?: number | null,
            atso?: number | null,
            ateo?: number | null,
            etfm?: number | null,
            etlm?: number | null,
            atfm?: number | null,
            atlm?: number | null,
            atn?: number | null,
            dtn?: number | null,
            systemAta?: number | null,
            systemAtd?: number | null,
            systemEta?: number | null,
            systemEtd?: number | null,
            location: {
              __typename?: 'Location',
              id: number,
              code?: string | null,
              displayCode?: string | null,
              description: string,
              type: Types.LocationType
            },
            voyage: {
              __typename?: 'Voyage',
              id: number,
              ship: {
                __typename?: 'Ship',
                id: number,
                name: string
              },
              creditor?: {
                __typename?: 'Relation',
                id: number,
                name: string
              } | null
            },
            cargos: Array<{
              __typename?: 'CargoAction',
              id: number,
              type: Types.CallType,
              location?: {
                __typename?: 'Location',
                displayCode?: string | null,
                code?: string | null,
                id: number,
                description: string,
                type: Types.LocationType
              } | null,
              cargo: {
                __typename?: 'Cargo',
                id: number
              }
            }>,
            linkedChildCalls: Array<{
              __typename?: 'Call',
              id: number,
              weight?: number | null,
              voyage: {
                __typename?: 'Voyage',
                id: number,
                voyageNumber: string,
                ship: {
                  __typename?: 'Ship',
                  id: number,
                  name: string
                }
              }
            }>
          }>
        },
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        }>,
        linkedChildCalls: Array<{
          __typename?: 'Call',
          id: number,
          weight?: number | null,
          voyage: {
            __typename?: 'Voyage',
            id: number,
            voyageNumber: string,
            ship: {
              __typename?: 'Ship',
              id: number,
              name: string
            }
          }
        }>
      }>,
      ship: {
        __typename?: 'Ship',
        id: number,
        name: string,
        bargeType?: Types.BargeType | null,
        lastShippedProducts?: Array<{
          __typename?: 'Product',
          id: number,
          code?: string | null,
          description?: string | null,
          name: string,
          densityKgM3?: number | null,
          adnGood?: {
            __typename?: 'ProductADNGood',
            id: number,
            unNumber?: number | null,
            descriptionDE?: string | null,
            descriptionEN?: string | null,
            descriptionNL?: string | null
          } | null,
          nstrGood?: {
            __typename?: 'ProductNSTRGood',
            id: number,
            nstrCode?: number | null,
            cargoGroup?: string | null
          } | null,
          idtfGood?: {
            __typename?: 'ProductIDTFGood',
            id: number,
            idtfNumber?: number | null,
            productName?: string | null
          } | null
        }> | null,
        tanks: Array<{
          __typename?: 'Tank',
          id: number,
          positionNumber: number,
          position: Types.TankPosition
        }>
      },
      lastShippedProducts?: Array<{
        __typename?: 'Product',
        id: number,
        code?: string | null,
        description?: string | null,
        name: string,
        densityKgM3?: number | null,
        adnGood?: {
          __typename?: 'ProductADNGood',
          id: number,
          unNumber?: number | null,
          descriptionDE?: string | null,
          descriptionEN?: string | null,
          descriptionNL?: string | null
        } | null,
        nstrGood?: {
          __typename?: 'ProductNSTRGood',
          id: number,
          nstrCode?: number | null,
          cargoGroup?: string | null
        } | null,
        idtfGood?: {
          __typename?: 'ProductIDTFGood',
          id: number,
          idtfNumber?: number | null,
          productName?: string | null
        } | null
      }> | null,
      statusChanges: Array<{
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      }>,
      lastStatusChange?: {
        __typename?: 'StatusChange',
        id: number,
        actualTime?: number | null,
        actualTimeOriginal?: number | null,
        actualTimeOverride?: number | null,
        estimateTime?: number | null,
        comment?: string | null,
        skipperComment?: string | null,
        timestamp?: number | null,
        appliedBy?: string | null,
        deletable: boolean,
        communicatedToCustomer?: number | null,
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }>,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null
        },
        supplier?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        origin?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean
            }>
          }
        } | null
      } | null
    } | null,
    charter?: {
      __typename?: 'SalesCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType,
      status: {
        __typename?: 'SalesCharterStatusType',
        name: Types.SalesCharterStatus,
        color: string,
        languageKeyPrefix: string
      },
      cargos: Array<{
        __typename?: 'Cargo',
        id: number,
        cargoNumber?: string | null,
        product?: {
          __typename?: 'Product',
          id: number,
          description?: string | null,
          name: string
        } | null
      }>,
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      }
    } | null
  } | null
};

export type GetCargoForCallSideviewerQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetCargoForCallSideviewerQuery = {
  __typename?: 'Query',
  cargo?: {
    __typename?: 'Cargo',
    id: number,
    cargoNumber?: string | null,
    containerNumber?: string | null,
    loadingReference?: string | null,
    dischargingReference?: string | null,
    productDetails?: string | null,
    charter?: {
      __typename?: 'SalesCharter',
      id: number,
      charterNumber: string,
      type: Types.CharterType
    } | null,
    product?: {
      __typename?: 'Product',
      id: number,
      code?: string | null,
      description?: string | null,
      name: string,
      densityKgM3?: number | null,
      adnGood?: {
        __typename?: 'ProductADNGood',
        id: number,
        unNumber?: number | null,
        descriptionDE?: string | null,
        descriptionEN?: string | null,
        descriptionNL?: string | null
      } | null,
      nstrGood?: {
        __typename?: 'ProductNSTRGood',
        id: number,
        nstrCode?: number | null,
        cargoGroup?: string | null
      } | null,
      idtfGood?: {
        __typename?: 'ProductIDTFGood',
        id: number,
        idtfNumber?: number | null,
        productName?: string | null
      } | null
    } | null,
    comments: Array<{
      __typename?: 'Comment',
      id: number,
      comment: string,
      created: number,
      createdBy: {
        __typename?: 'AccountDetails',
        id: number,
        username?: string | null,
        displayName?: string | null
      },
      label?: {
        __typename?: 'Label',
        id: number,
        type: Types.LabelType,
        text: string,
        color: string
      } | null
    }>,
    documents?: Array<{
      __typename?: 'Document',
      id: number
    } | null> | null,
    supplier?: {
      __typename?: 'Relation',
      id: number,
      name: string,
      isApplicationRelation?: boolean | null
    } | null,
    deliveryCondition?: {
      __typename?: 'DeliveryCondition',
      id: number
    } | null,
    actions: Array<{
      __typename?: 'CargoAction',
      id: number,
      type: Types.CallType,
      weight?: number | null,
      volume?: number | null,
      start?: number | null,
      end?: number | null,
      displayAsWindow?: boolean | null,
      timesheetNote?: string | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string,
        code?: string | null,
        displayCode?: string | null,
        type: Types.LocationType,
        locationGroups: Array<{
          __typename?: 'Location',
          id: number,
          description: string,
          code?: string | null,
          type: Types.LocationType
        }>
      } | null,
      call?: {
        __typename?: 'Call',
        id: number
      } | null,
      cargo: {
        __typename?: 'Cargo',
        id: number,
        cargoNumber?: string | null,
        lastStatusChange?: {
          __typename?: 'StatusChange',
          status: {
            __typename?: 'Status',
            id: number,
            statusOrder?: number | null,
            cargoActionType?: Types.CallType | null,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean
          }
        } | null,
        statusChanges: Array<{
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            statusOrder?: number | null,
            cargoActionType?: Types.CallType | null,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean
          }
        }>
      },
      measurements: {
        __typename?: 'Measurements',
        locationWeight?: number | null,
        locationWeightUnit?: Types.WeightUnit | null,
        skipperWeight?: number | null,
        skipperWeightUnit?: Types.WeightUnit | null,
        locationVolume?: number | null,
        locationVolumeUnit?: Types.VolumeUnit | null,
        skipperVolume?: number | null,
        skipperVolumeUnit?: Types.VolumeUnit | null,
        ambientVolume?: number | null,
        relativeDensity?: number | null,
        productTemperature?: number | null,
        actualConsignor?: string | null,
        actualConsignee?: string | null,
        protest?: boolean | null
      }
    }>,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>
  } | null
};

export type GetCargoQueryVariables = Types.Exact<{
  id: Types.Scalars['Long']['input'];
}>;


export type GetCargoQuery = {
  __typename?: 'Query',
  cargo?: {
    __typename?: 'Cargo',
    id: number,
    reference?: string | null,
    loadingReference?: string | null,
    dischargingReference?: string | null,
    containerNumber?: string | null,
    cargoNumber?: string | null,
    nominationNumber?: string | null,
    isNitrogenPurgingRequired: boolean,
    isHoseRentalRequired: boolean,
    isCleaningRequired: boolean,
    waterLevelOptimised: boolean,
    weightOptionPercentage?: number | null,
    weightToleranceType?: Types.WeightToleranceType | null,
    weightOptionType?: Types.WeightOptionType | null,
    declaredFinalWeight?: number | null,
    weight?: number | null,
    volume?: number | null,
    grossWeight?: number | null,
    tareWeight?: number | null,
    verifiedGrossWeight?: number | null,
    hasDangerousGoods?: boolean | null,
    empty?: boolean | null,
    desiredTemperature?: number | null,
    temperatureRangeLower?: number | null,
    temperatureRangeUpper?: number | null,
    sealed?: boolean | null,
    sealNumber?: string | null,
    waNumber?: string | null,
    bookingReference?: string | null,
    loaded?: number | null,
    discharged?: number | null,
    transportType?: Types.TransportType | null,
    productDetails?: string | null,
    reeferCheckType?: Types.ReeferCheckType | null,
    imoClass?: string | null,
    billOfLadingNumber?: string | null,
    humidity?: number | null,
    remarks?: string | null,
    scacCode?: string | null,
    scacCodeDischarging?: string | null,
    overheight?: number | null,
    overlength?: number | null,
    overlengthBehind?: number | null,
    overwidthRight?: number | null,
    overwidthLeft?: number | null,
    doorOpen?: boolean | null,
    chains?: boolean | null,
    generator?: boolean | null,
    damage?: string | null,
    releasedForBarge?: boolean | null,
    releasedForTrain?: boolean | null,
    releasedForTruck?: boolean | null,
    masterBundleContainerNumber?: string | null,
    deepseaShipNameLoading?: string | null,
    deepseaShipImoLoading?: number | null,
    deepseaVoyageNumberLoading?: string | null,
    deepseaEtaLoading?: number | null,
    deepseaShipNameDischarging?: string | null,
    deepseaShipImoDischarging?: number | null,
    deepseaVoyageNumberDischarging?: string | null,
    deepseaEtaDischarging?: number | null,
    deepseaEstimateDischarge?: number | null,
    previousPort?: string | null,
    nextPort?: string | null,
    finalPort?: string | null,
    revenue?: number | null,
    teu?: number | null,
    isInhibitedProduct: boolean,
    isTemperatureControlRequired: boolean,
    isNitrogenBlanketingRequired: boolean,
    connectingVisitLoadingCallReferenceNumber?: string | null,
    connectingVisitDischargingCallReferenceNumber?: string | null,
    containerType?: {
      __typename?: 'ContainerType',
      isoTypeCode: string,
      displayCode?: string | null,
      teu: number
    } | null,
    product?: {
      __typename?: 'Product',
      id: number,
      code?: string | null,
      name: string,
      description?: string | null
    } | null,
    containerOperator?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    supplier?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    consignor?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    consignee?: {
      __typename?: 'Relation',
      id: number,
      name: string
    } | null,
    unNumbers?: Array<{
      __typename?: 'UnNumber',
      id: number,
      unNumberId: string
    } | null> | null,
    deliveryCondition?: {
      __typename?: 'DeliveryCondition',
      id: number,
      description: string
    } | null,
    previousInlandTerminal?: {
      __typename?: 'Location',
      id: number,
      description: string
    } | null,
    nextInlandTerminal?: {
      __typename?: 'Location',
      id: number,
      description: string
    } | null,
    charter?: {
      __typename?: 'SalesCharter',
      customerReference?: string | null,
      id: number,
      type: Types.CharterType,
      charterNumber: string,
      debtor: {
        __typename?: 'Relation',
        id: number,
        name: string
      }
    } | null,
    voyage?: {
      __typename?: 'Voyage',
      id: number,
      voyageNumber: string,
      ship: {
        __typename?: 'Ship',
        id: number,
        name: string
      }
    } | null,
    actions: Array<{
      __typename?: 'CargoAction',
      id: number,
      type: Types.CallType,
      start?: number | null,
      end?: number | null,
      simulatedTimestamp?: boolean | null,
      displayAsWindow?: boolean | null,
      reference?: string | null,
      notes?: string | null,
      terminalPlanningNotes?: string | null,
      weight?: number | null,
      volume?: number | null,
      location?: {
        __typename?: 'Location',
        id: number,
        description: string,
        abbreviation?: string | null
      } | null,
      surveyor?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      call?: {
        __typename?: 'Call',
        id: number,
        pta?: number | null,
        eta?: number | null,
        ata?: number | null,
        ptd?: number | null,
        etd?: number | null,
        atd?: number | null,
        etso?: number | null,
        eteo?: number | null,
        atso?: number | null,
        ateo?: number | null,
        etfm?: number | null,
        etlm?: number | null,
        atfm?: number | null,
        atlm?: number | null,
        atn?: number | null,
        dtn?: number | null,
        systemAta?: number | null,
        systemAtd?: number | null,
        systemEta?: number | null,
        systemEtd?: number | null,
        voyage: {
          __typename?: 'Voyage',
          id: number,
          voyageNumber: string,
          ship: {
            __typename?: 'Ship',
            id: number,
            name: string
          }
        },
        lastStatusChange?: {
          __typename?: 'StatusChange',
          id: number,
          actualTime?: number | null,
          actualTimeOriginal?: number | null,
          actualTimeOverride?: number | null,
          estimateTime?: number | null,
          comment?: string | null,
          skipperComment?: string | null,
          timestamp?: number | null,
          appliedBy?: string | null,
          deletable: boolean,
          communicatedToCustomer?: number | null,
          status: {
            __typename?: 'Status',
            id: number,
            description: string,
            type: Types.StatusType,
            cargoActionType?: Types.CallType | null,
            color: string,
            statusOrder?: number | null,
            supplierRequired: boolean,
            skipperRequiredFillInSailingReport: boolean,
            skipperRequiredFillInWeightVolume: boolean,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean,
            requireActualTime: Types.StatusActualTimeType,
            estimateType?: Types.StatusEstimateType | null,
            estimateRequirement: Types.StatusEstimateRequirement,
            shouldLoadOnTerminal: boolean,
            closedStatus: boolean,
            cancelledStatus: boolean,
            loadedStatus: boolean,
            dischargedStatus: boolean,
            finishedStatus: boolean,
            allowComment: boolean,
            allowSkipperComment: boolean,
            shouldUpdateJDE: boolean,
            isInProgress: boolean,
            voyageVisibleBySkipper: boolean,
            voyageVisibleByCreditor: boolean,
            voyageEditableBySkipper: boolean,
            voyageEditableByCreditor: boolean,
            callVisibleByLocationOwner: boolean,
            isRejectStatus: boolean,
            isAcceptStatus: boolean,
            notifySkippers: boolean,
            notifyShipManagers: boolean,
            notifyShipOwners: boolean,
            notifyOperators: boolean,
            notifyCustomers: boolean,
            notifyTerminals: boolean,
            isCustomerNominatingStatus: boolean,
            isSkipperNominatingStatus: boolean,
            includeInNominationExport: boolean,
            laytimeStartStatus: boolean,
            laytimeEndStatus: boolean,
            requireDocuments: boolean,
            showConfirmMessage: boolean,
            expiringStatus: boolean,
            isActionStatus: boolean,
            requireTanks: boolean,
            successiveStatuses: Array<{
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              description: string,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }>,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean,
              type?: Types.SendDocumentType | null,
              target?: Types.DocumentTarget | null
            } | null,
            translations?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            confirmMessages?: {
              __typename?: 'LanguageDescription',
              id: number,
              defaultValue?: string | null,
              descriptions: Array<{
                __typename?: 'TranslationKeyValuePair',
                key: string,
                value: string
              }>
            } | null,
            rules?: Array<{
              __typename?: 'Rule',
              id: number,
              ifFitsStatusFlow: boolean,
              ifNotAppliedBefore: boolean,
              ruleType: {
                __typename?: 'RuleType',
                name: Types.StatusRule
              },
              targetStatus: {
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                supplierRequired: boolean,
                description: string,
                sendDocument?: {
                  __typename?: 'SendDocumentStatus',
                  enabled: boolean
                } | null
              }
            }> | null
          },
          supplier?: {
            __typename?: 'Relation',
            id: number,
            name: string
          } | null,
          origin?: {
            __typename?: 'StatusChange',
            status: {
              __typename?: 'Status',
              id: number,
              description: string,
              type: Types.StatusType,
              cargoActionType?: Types.CallType | null,
              color: string,
              statusOrder?: number | null,
              supplierRequired: boolean,
              skipperRequiredFillInSailingReport: boolean,
              skipperRequiredFillInWeightVolume: boolean,
              applyByCustomer: boolean,
              applyBySkipper: boolean,
              applyByTerminal: boolean,
              requireActualTime: Types.StatusActualTimeType,
              estimateType?: Types.StatusEstimateType | null,
              estimateRequirement: Types.StatusEstimateRequirement,
              shouldLoadOnTerminal: boolean,
              closedStatus: boolean,
              cancelledStatus: boolean,
              loadedStatus: boolean,
              dischargedStatus: boolean,
              finishedStatus: boolean,
              allowComment: boolean,
              allowSkipperComment: boolean,
              shouldUpdateJDE: boolean,
              isInProgress: boolean,
              voyageVisibleBySkipper: boolean,
              voyageVisibleByCreditor: boolean,
              voyageEditableBySkipper: boolean,
              voyageEditableByCreditor: boolean,
              callVisibleByLocationOwner: boolean,
              isRejectStatus: boolean,
              isAcceptStatus: boolean,
              notifySkippers: boolean,
              notifyShipManagers: boolean,
              notifyShipOwners: boolean,
              notifyOperators: boolean,
              notifyCustomers: boolean,
              notifyTerminals: boolean,
              isCustomerNominatingStatus: boolean,
              isSkipperNominatingStatus: boolean,
              includeInNominationExport: boolean,
              laytimeStartStatus: boolean,
              laytimeEndStatus: boolean,
              requireDocuments: boolean,
              showConfirmMessage: boolean,
              expiringStatus: boolean,
              isActionStatus: boolean,
              requireTanks: boolean,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean,
                type?: Types.SendDocumentType | null,
                target?: Types.DocumentTarget | null
              } | null,
              translations?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              confirmMessages?: {
                __typename?: 'LanguageDescription',
                id: number,
                defaultValue?: string | null,
                descriptions: Array<{
                  __typename?: 'TranslationKeyValuePair',
                  key: string,
                  value: string
                }>
              } | null,
              rules?: Array<{
                __typename?: 'Rule',
                id: number,
                ifFitsStatusFlow: boolean,
                ifNotAppliedBefore: boolean,
                ruleType: {
                  __typename?: 'RuleType',
                  name: Types.StatusRule
                },
                targetStatus: {
                  __typename?: 'Status',
                  id: number,
                  type: Types.StatusType,
                  supplierRequired: boolean,
                  description: string,
                  sendDocument?: {
                    __typename?: 'SendDocumentStatus',
                    enabled: boolean
                  } | null
                }
              }> | null,
              successiveStatuses: Array<{
                __typename?: 'Status',
                id: number,
                type: Types.StatusType,
                description: string,
                applyByCustomer: boolean,
                applyBySkipper: boolean,
                applyByTerminal: boolean
              }>
            }
          } | null
        } | null
      } | null,
      connectingShipPortVisit?: {
        __typename?: 'ConnectingShipPortVisit',
        id: number,
        from?: number | null,
        until?: number | null,
        lastUpdateFromAgentOn?: number | null,
        location: {
          __typename?: 'Location',
          id: number,
          description: string,
          type: Types.LocationType,
          locationGroups: Array<{
            __typename?: 'Location',
            code?: string | null,
            id: number,
            description: string,
            type: Types.LocationType
          }>
        },
        agent?: {
          __typename?: 'Relation',
          id: number,
          name: string
        } | null,
        ship: {
          __typename?: 'Ship',
          id: number,
          name: string,
          bargeType?: Types.BargeType | null,
          mmsi?: number | null,
          eni?: string | null,
          planningNotes?: string | null,
          tanks: Array<{
            __typename?: 'Tank',
            id: number,
            positionNumber: number
          }>
        },
        connectingShipBerthings?: Array<{
          __typename?: 'ConnectingShipBerthing',
          window?: {
            __typename?: 'TimeWindow',
            from?: number | null,
            to?: number | null
          } | null,
          location?: {
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType,
            locationGroups: Array<{
              __typename?: 'Location',
              code?: string | null,
              id: number,
              description: string,
              type: Types.LocationType
            }>
          } | null
        }> | null
      } | null,
      connectingShipBerthing?: {
        __typename?: 'ConnectingShipBerthing',
        id?: number | null,
        window?: {
          __typename?: 'TimeWindow',
          from?: number | null,
          to?: number | null
        } | null,
        location?: {
          __typename?: 'Location',
          id: number,
          description: string,
          locationGroups: Array<{
            __typename?: 'Location',
            id: number,
            description: string,
            type: Types.LocationType
          }>
        } | null
      } | null
    }>,
    statusChanges: Array<{
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    }>,
    lastStatusChange?: {
      __typename?: 'StatusChange',
      id: number,
      actualTime?: number | null,
      actualTimeOriginal?: number | null,
      actualTimeOverride?: number | null,
      estimateTime?: number | null,
      comment?: string | null,
      skipperComment?: string | null,
      timestamp?: number | null,
      appliedBy?: string | null,
      deletable: boolean,
      communicatedToCustomer?: number | null,
      status: {
        __typename?: 'Status',
        id: number,
        description: string,
        type: Types.StatusType,
        cargoActionType?: Types.CallType | null,
        color: string,
        statusOrder?: number | null,
        supplierRequired: boolean,
        skipperRequiredFillInSailingReport: boolean,
        skipperRequiredFillInWeightVolume: boolean,
        applyByCustomer: boolean,
        applyBySkipper: boolean,
        applyByTerminal: boolean,
        requireActualTime: Types.StatusActualTimeType,
        estimateType?: Types.StatusEstimateType | null,
        estimateRequirement: Types.StatusEstimateRequirement,
        shouldLoadOnTerminal: boolean,
        closedStatus: boolean,
        cancelledStatus: boolean,
        loadedStatus: boolean,
        dischargedStatus: boolean,
        finishedStatus: boolean,
        allowComment: boolean,
        allowSkipperComment: boolean,
        shouldUpdateJDE: boolean,
        isInProgress: boolean,
        voyageVisibleBySkipper: boolean,
        voyageVisibleByCreditor: boolean,
        voyageEditableBySkipper: boolean,
        voyageEditableByCreditor: boolean,
        callVisibleByLocationOwner: boolean,
        isRejectStatus: boolean,
        isAcceptStatus: boolean,
        notifySkippers: boolean,
        notifyShipManagers: boolean,
        notifyShipOwners: boolean,
        notifyOperators: boolean,
        notifyCustomers: boolean,
        notifyTerminals: boolean,
        isCustomerNominatingStatus: boolean,
        isSkipperNominatingStatus: boolean,
        includeInNominationExport: boolean,
        laytimeStartStatus: boolean,
        laytimeEndStatus: boolean,
        requireDocuments: boolean,
        showConfirmMessage: boolean,
        expiringStatus: boolean,
        isActionStatus: boolean,
        requireTanks: boolean,
        successiveStatuses: Array<{
          __typename?: 'Status',
          id: number,
          type: Types.StatusType,
          description: string,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }>,
        sendDocument?: {
          __typename?: 'SendDocumentStatus',
          enabled: boolean,
          type?: Types.SendDocumentType | null,
          target?: Types.DocumentTarget | null
        } | null,
        translations?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        confirmMessages?: {
          __typename?: 'LanguageDescription',
          id: number,
          defaultValue?: string | null,
          descriptions: Array<{
            __typename?: 'TranslationKeyValuePair',
            key: string,
            value: string
          }>
        } | null,
        rules?: Array<{
          __typename?: 'Rule',
          id: number,
          ifFitsStatusFlow: boolean,
          ifNotAppliedBefore: boolean,
          ruleType: {
            __typename?: 'RuleType',
            name: Types.StatusRule
          },
          targetStatus: {
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            supplierRequired: boolean,
            description: string,
            sendDocument?: {
              __typename?: 'SendDocumentStatus',
              enabled: boolean
            } | null
          }
        }> | null
      },
      supplier?: {
        __typename?: 'Relation',
        id: number,
        name: string
      } | null,
      origin?: {
        __typename?: 'StatusChange',
        status: {
          __typename?: 'Status',
          id: number,
          description: string,
          type: Types.StatusType,
          cargoActionType?: Types.CallType | null,
          color: string,
          statusOrder?: number | null,
          supplierRequired: boolean,
          skipperRequiredFillInSailingReport: boolean,
          skipperRequiredFillInWeightVolume: boolean,
          applyByCustomer: boolean,
          applyBySkipper: boolean,
          applyByTerminal: boolean,
          requireActualTime: Types.StatusActualTimeType,
          estimateType?: Types.StatusEstimateType | null,
          estimateRequirement: Types.StatusEstimateRequirement,
          shouldLoadOnTerminal: boolean,
          closedStatus: boolean,
          cancelledStatus: boolean,
          loadedStatus: boolean,
          dischargedStatus: boolean,
          finishedStatus: boolean,
          allowComment: boolean,
          allowSkipperComment: boolean,
          shouldUpdateJDE: boolean,
          isInProgress: boolean,
          voyageVisibleBySkipper: boolean,
          voyageVisibleByCreditor: boolean,
          voyageEditableBySkipper: boolean,
          voyageEditableByCreditor: boolean,
          callVisibleByLocationOwner: boolean,
          isRejectStatus: boolean,
          isAcceptStatus: boolean,
          notifySkippers: boolean,
          notifyShipManagers: boolean,
          notifyShipOwners: boolean,
          notifyOperators: boolean,
          notifyCustomers: boolean,
          notifyTerminals: boolean,
          isCustomerNominatingStatus: boolean,
          isSkipperNominatingStatus: boolean,
          includeInNominationExport: boolean,
          laytimeStartStatus: boolean,
          laytimeEndStatus: boolean,
          requireDocuments: boolean,
          showConfirmMessage: boolean,
          expiringStatus: boolean,
          isActionStatus: boolean,
          requireTanks: boolean,
          sendDocument?: {
            __typename?: 'SendDocumentStatus',
            enabled: boolean,
            type?: Types.SendDocumentType | null,
            target?: Types.DocumentTarget | null
          } | null,
          translations?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          confirmMessages?: {
            __typename?: 'LanguageDescription',
            id: number,
            defaultValue?: string | null,
            descriptions: Array<{
              __typename?: 'TranslationKeyValuePair',
              key: string,
              value: string
            }>
          } | null,
          rules?: Array<{
            __typename?: 'Rule',
            id: number,
            ifFitsStatusFlow: boolean,
            ifNotAppliedBefore: boolean,
            ruleType: {
              __typename?: 'RuleType',
              name: Types.StatusRule
            },
            targetStatus: {
              __typename?: 'Status',
              id: number,
              type: Types.StatusType,
              supplierRequired: boolean,
              description: string,
              sendDocument?: {
                __typename?: 'SendDocumentStatus',
                enabled: boolean
              } | null
            }
          }> | null,
          successiveStatuses: Array<{
            __typename?: 'Status',
            id: number,
            type: Types.StatusType,
            description: string,
            applyByCustomer: boolean,
            applyBySkipper: boolean,
            applyByTerminal: boolean
          }>
        }
      } | null
    } | null,
    comments: Array<{
      __typename?: 'Comment',
      id: number,
      comment: string,
      created: number,
      createdBy: {
        __typename?: 'AccountDetails',
        id: number,
        username?: string | null,
        displayName?: string | null
      },
      label?: {
        __typename?: 'Label',
        id: number,
        type: Types.LabelType,
        text: string,
        color: string
      } | null
    }>
  } | null
};


export const GetAllAdnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllAdn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAdn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"identifier"}},{"kind":"Field","name":{"kind":"Name","value":"unNumber"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEN"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionNL"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionFR"}}]}}]}}]} as unknown as DocumentNode<GetAllAdnQuery, GetAllAdnQueryVariables>;
export const GetCargosForVoyagePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCargosForVoyagePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dischargingSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"loadingSearch"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CargoSearch"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"loadingCargos"},"name":{"kind":"Name","value":"cargos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"loadingSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoForVoyagePlan"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"dischargingCargos"},"name":{"kind":"Name","value":"cargos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dischargingSearch"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalElements"}},{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoForVoyagePlan"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoForVoyagePlan"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Cargo"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"empty"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"transportType"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"grossWeight"}},{"kind":"Field","name":{"kind":"Name","value":"tareWeight"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedGrossWeight"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}}]} as unknown as DocumentNode<GetCargosForVoyagePlanQuery, GetCargosForVoyagePlanQueryVariables>;
export const GetPreviousCargoesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPreviousCargoes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Pagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previousCargoes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shipId"}}},{"kind":"Argument","name":{"kind":"Name","value":"charterId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"charterId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"previousCargoDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"atd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalElements"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}}]} as unknown as DocumentNode<GetPreviousCargoesQuery, GetPreviousCargoesQueryVariables>;
export const GetCargoForSideviewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCargoForSideviewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"densityKgM3"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"empty"}},{"kind":"Field","name":{"kind":"Name","value":"tareWeight"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"grossWeight"}},{"kind":"Field","name":{"kind":"Name","value":"sealNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"shipToShip"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralCall"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"lastShippedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"productWithGoods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastShippedProductsFreeText"}},{"kind":"Field","name":{"kind":"Name","value":"lastShippedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"productWithGoods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"languageKeyPrefix"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualStatusCode"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"loadedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedWeight"}},{"kind":"Field","name":{"kind":"Name","value":"mostAccurateArrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"mostAccurateDepartureTime"}},{"kind":"Field","name":{"kind":"Name","value":"anglerCallInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skipperWeightMTon"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeL15"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightMTon"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeL15"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"callDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"callLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTwinCall"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfLoadingContainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"numberOfContainersFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDischargingContainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"numberOfContainersFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfLoadingReeferContainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"numberOfContainersFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"numberOfDischargingReeferContainers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"numberOfContainersFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dischargingCargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lengthFt"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lengthFt"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalLoadingWeight"}},{"kind":"Field","name":{"kind":"Name","value":"totalDischargingWeight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"loadingCargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lengthFt"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lengthFt"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalLoadingWeight"}},{"kind":"Field","name":{"kind":"Name","value":"totalDischargingWeight"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"town"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nrLoadingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"nrDischargingCargos"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedLoadingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"expectedDischargingTeu"}},{"kind":"Field","name":{"kind":"Name","value":"startPortChargeCountingTime"}},{"kind":"Field","name":{"kind":"Name","value":"startPortChargeCountingTimeOperator"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"allSuppliersConfigured"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"documentFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"firstLoadingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastDischargingAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"end"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultCharterSubtype"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}},{"kind":"Field","name":{"kind":"Name","value":"capacityM3"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"purchaseCharters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastShippedProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"productWithGoods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastShippedProductsFreeText"}},{"kind":"Field","name":{"kind":"Name","value":"from"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"to"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallSideviewerCall"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isBallast"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedChildCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"numberOfContainersFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NumberOfContainers"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numEmptyLessThanOrEqualTo20ft"}},{"kind":"Field","name":{"kind":"Name","value":"numEmptyFrom21ftThrough30ft"}},{"kind":"Field","name":{"kind":"Name","value":"numEmptyFrom31ftThrough40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numEmptyGreaterThan40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFullLessThanOrEqualTo20ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFullFrom21ftThrough30ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFullFrom31ftThrough40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFullGreaterThan40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numLessThanOrEqualTo20ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFrom21ftThrough30ft"}},{"kind":"Field","name":{"kind":"Name","value":"numFrom31ftThrough40ft"}},{"kind":"Field","name":{"kind":"Name","value":"numGreaterThan40ft"}},{"kind":"Field","name":{"kind":"Name","value":"totalTeu"}},{"kind":"Field","name":{"kind":"Name","value":"numTotalFullContainers"}},{"kind":"Field","name":{"kind":"Name","value":"numTotalEmptyContainers"}},{"kind":"Field","name":{"kind":"Name","value":"numTotalContainers"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"documentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"issuedAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"documentEntity"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"documentEntity"}},{"kind":"Field","name":{"kind":"Name","value":"documentType"}},{"kind":"Field","name":{"kind":"Name","value":"validUntil"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusUpdateOn"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionId"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"inactivityType"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productWithGoods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"densityKgM3"}},{"kind":"Field","name":{"kind":"Name","value":"adnGood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unNumber"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionDE"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEN"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionNL"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nstrGood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nstrCode"}},{"kind":"Field","name":{"kind":"Name","value":"cargoGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idtfGood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idtfNumber"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallSideviewerCall"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualStatusCode"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"creditor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkedChildCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTimes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"atso"}},{"kind":"Field","name":{"kind":"Name","value":"ateo"}},{"kind":"Field","name":{"kind":"Name","value":"etfm"}},{"kind":"Field","name":{"kind":"Name","value":"etlm"}},{"kind":"Field","name":{"kind":"Name","value":"atfm"}},{"kind":"Field","name":{"kind":"Name","value":"atlm"}},{"kind":"Field","name":{"kind":"Name","value":"atn"}},{"kind":"Field","name":{"kind":"Name","value":"dtn"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEtd"}}]}}]} as unknown as DocumentNode<GetCargoForSideviewerQuery, GetCargoForSideviewerQueryVariables>;
export const GetCargoForCallSideviewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCargoForCallSideviewer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingReference"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"productWithGoods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isApplicationRelation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deliveryCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetCargoAction"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timesheetNote"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"cargoActionActuals"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"cargoActionActuals"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationWeight"}},{"kind":"Field","name":{"kind":"Name","value":"locationWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeight"}},{"kind":"Field","name":{"kind":"Name","value":"skipperWeightUnit"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolume"}},{"kind":"Field","name":{"kind":"Name","value":"locationVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolume"}},{"kind":"Field","name":{"kind":"Name","value":"skipperVolumeUnit"}},{"kind":"Field","name":{"kind":"Name","value":"ambientVolume"}},{"kind":"Field","name":{"kind":"Name","value":"relativeDensity"}},{"kind":"Field","name":{"kind":"Name","value":"productTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignor"}},{"kind":"Field","name":{"kind":"Name","value":"actualConsignee"}},{"kind":"Field","name":{"kind":"Name","value":"protest"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productWithGoods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"densityKgM3"}},{"kind":"Field","name":{"kind":"Name","value":"adnGood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unNumber"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionDE"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionEN"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionNL"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nstrGood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nstrCode"}},{"kind":"Field","name":{"kind":"Name","value":"cargoGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idtfGood"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idtfNumber"}},{"kind":"Field","name":{"kind":"Name","value":"productName"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetCargoAction"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CargoAction"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"timesheetNote"}},{"kind":"Field","name":{"kind":"Name","value":"cargo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VoyageTimesheetStatus"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VoyageTimesheetStatus"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}}]}}]} as unknown as DocumentNode<GetCargoForCallSideviewerQuery, GetCargoForCallSideviewerQueryVariables>;
export const GetCargoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCargo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Long"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cargo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"loadingReference"}},{"kind":"Field","name":{"kind":"Name","value":"dischargingReference"}},{"kind":"Field","name":{"kind":"Name","value":"containerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"cargoNumber"}},{"kind":"Field","name":{"kind":"Name","value":"nominationNumber"}},{"kind":"Field","name":{"kind":"Name","value":"containerType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isoTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"displayCode"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"containerOperator"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"consignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenPurgingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isHoseRentalRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isCleaningRequired"}},{"kind":"Field","name":{"kind":"Name","value":"waterLevelOptimised"}},{"kind":"Field","name":{"kind":"Name","value":"weightOptionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"weightToleranceType"}},{"kind":"Field","name":{"kind":"Name","value":"weightOptionType"}},{"kind":"Field","name":{"kind":"Name","value":"declaredFinalWeight"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"grossWeight"}},{"kind":"Field","name":{"kind":"Name","value":"tareWeight"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedGrossWeight"}},{"kind":"Field","name":{"kind":"Name","value":"unNumbers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"unNumberId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasDangerousGoods"}},{"kind":"Field","name":{"kind":"Name","value":"empty"}},{"kind":"Field","name":{"kind":"Name","value":"desiredTemperature"}},{"kind":"Field","name":{"kind":"Name","value":"temperatureRangeLower"}},{"kind":"Field","name":{"kind":"Name","value":"temperatureRangeUpper"}},{"kind":"Field","name":{"kind":"Name","value":"sealed"}},{"kind":"Field","name":{"kind":"Name","value":"sealNumber"}},{"kind":"Field","name":{"kind":"Name","value":"waNumber"}},{"kind":"Field","name":{"kind":"Name","value":"bookingReference"}},{"kind":"Field","name":{"kind":"Name","value":"loaded"}},{"kind":"Field","name":{"kind":"Name","value":"discharged"}},{"kind":"Field","name":{"kind":"Name","value":"transportType"}},{"kind":"Field","name":{"kind":"Name","value":"productDetails"}},{"kind":"Field","name":{"kind":"Name","value":"reeferCheckType"}},{"kind":"Field","name":{"kind":"Name","value":"imoClass"}},{"kind":"Field","name":{"kind":"Name","value":"billOfLadingNumber"}},{"kind":"Field","name":{"kind":"Name","value":"humidity"}},{"kind":"Field","name":{"kind":"Name","value":"remarks"}},{"kind":"Field","name":{"kind":"Name","value":"scacCode"}},{"kind":"Field","name":{"kind":"Name","value":"scacCodeDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"overheight"}},{"kind":"Field","name":{"kind":"Name","value":"overlength"}},{"kind":"Field","name":{"kind":"Name","value":"overlengthBehind"}},{"kind":"Field","name":{"kind":"Name","value":"overwidthRight"}},{"kind":"Field","name":{"kind":"Name","value":"overwidthLeft"}},{"kind":"Field","name":{"kind":"Name","value":"doorOpen"}},{"kind":"Field","name":{"kind":"Name","value":"chains"}},{"kind":"Field","name":{"kind":"Name","value":"generator"}},{"kind":"Field","name":{"kind":"Name","value":"damage"}},{"kind":"Field","name":{"kind":"Name","value":"releasedForBarge"}},{"kind":"Field","name":{"kind":"Name","value":"releasedForTrain"}},{"kind":"Field","name":{"kind":"Name","value":"releasedForTruck"}},{"kind":"Field","name":{"kind":"Name","value":"masterBundleContainerNumber"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaShipNameLoading"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaShipImoLoading"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaVoyageNumberLoading"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaEtaLoading"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaShipNameDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaShipImoDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaVoyageNumberDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaEtaDischarging"}},{"kind":"Field","name":{"kind":"Name","value":"deepseaEstimateDischarge"}},{"kind":"Field","name":{"kind":"Name","value":"deliveryCondition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousInlandTerminal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextInlandTerminal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousPort"}},{"kind":"Field","name":{"kind":"Name","value":"nextPort"}},{"kind":"Field","name":{"kind":"Name","value":"finalPort"}},{"kind":"Field","name":{"kind":"Name","value":"revenue"}},{"kind":"Field","name":{"kind":"Name","value":"teu"}},{"kind":"Field","name":{"kind":"Name","value":"isInhibitedProduct"}},{"kind":"Field","name":{"kind":"Name","value":"isTemperatureControlRequired"}},{"kind":"Field","name":{"kind":"Name","value":"isNitrogenBlanketingRequired"}},{"kind":"Field","name":{"kind":"Name","value":"charter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"charterNumber"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SalesCharter"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerReference"}}]}},{"kind":"Field","name":{"kind":"Name","value":"debtor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"simulatedTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"displayAsWindow"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"abbreviation"}}]}},{"kind":"Field","name":{"kind":"Name","value":"surveyor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"terminalPlanningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"call"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CallTimes"}},{"kind":"Field","name":{"kind":"Name","value":"voyage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voyageNumber"}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipPortVisit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GeneralConnectingShipPortVisit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusChanges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastStatusChange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusChangeFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"comment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitLoadingCallReferenceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"connectingVisitDischargingCallReferenceNumber"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusChangeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StatusChange"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actualTime"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOriginal"}},{"kind":"Field","name":{"kind":"Name","value":"actualTimeOverride"}},{"kind":"Field","name":{"kind":"Name","value":"estimateTime"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"skipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"appliedBy"}},{"kind":"Field","name":{"kind":"Name","value":"deletable"}},{"kind":"Field","name":{"kind":"Name","value":"communicatedToCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"origin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"statusFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"statusFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Status"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cargoActionType"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"target"}}]}},{"kind":"Field","name":{"kind":"Name","value":"translations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmMessages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"statusOrder"}},{"kind":"Field","name":{"kind":"Name","value":"rules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ruleType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"targetStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sendDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ifFitsStatusFlow"}},{"kind":"Field","name":{"kind":"Name","value":"ifNotAppliedBefore"}}]}},{"kind":"Field","name":{"kind":"Name","value":"supplierRequired"}},{"kind":"Field","name":{"kind":"Name","value":"successiveStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInSailingReport"}},{"kind":"Field","name":{"kind":"Name","value":"skipperRequiredFillInWeightVolume"}},{"kind":"Field","name":{"kind":"Name","value":"applyByCustomer"}},{"kind":"Field","name":{"kind":"Name","value":"applyBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"applyByTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"requireActualTime"}},{"kind":"Field","name":{"kind":"Name","value":"estimateType"}},{"kind":"Field","name":{"kind":"Name","value":"estimateRequirement"}},{"kind":"Field","name":{"kind":"Name","value":"shouldLoadOnTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"closedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledStatus"}},{"kind":"Field","name":{"kind":"Name","value":"loadedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"dischargedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"finishedStatus"}},{"kind":"Field","name":{"kind":"Name","value":"allowComment"}},{"kind":"Field","name":{"kind":"Name","value":"allowSkipperComment"}},{"kind":"Field","name":{"kind":"Name","value":"shouldUpdateJDE"}},{"kind":"Field","name":{"kind":"Name","value":"isInProgress"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageVisibleByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableBySkipper"}},{"kind":"Field","name":{"kind":"Name","value":"voyageEditableByCreditor"}},{"kind":"Field","name":{"kind":"Name","value":"callVisibleByLocationOwner"}},{"kind":"Field","name":{"kind":"Name","value":"isRejectStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isAcceptStatus"}},{"kind":"Field","name":{"kind":"Name","value":"notifySkippers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipManagers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyShipOwners"}},{"kind":"Field","name":{"kind":"Name","value":"notifyOperators"}},{"kind":"Field","name":{"kind":"Name","value":"notifyCustomers"}},{"kind":"Field","name":{"kind":"Name","value":"notifyTerminals"}},{"kind":"Field","name":{"kind":"Name","value":"isCustomerNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isSkipperNominatingStatus"}},{"kind":"Field","name":{"kind":"Name","value":"includeInNominationExport"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeStartStatus"}},{"kind":"Field","name":{"kind":"Name","value":"laytimeEndStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireDocuments"}},{"kind":"Field","name":{"kind":"Name","value":"showConfirmMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiringStatus"}},{"kind":"Field","name":{"kind":"Name","value":"isActionStatus"}},{"kind":"Field","name":{"kind":"Name","value":"requireTanks"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"comment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Comment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"label"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"color"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CompactLocation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CallTimes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Call"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pta"}},{"kind":"Field","name":{"kind":"Name","value":"eta"}},{"kind":"Field","name":{"kind":"Name","value":"ata"}},{"kind":"Field","name":{"kind":"Name","value":"ptd"}},{"kind":"Field","name":{"kind":"Name","value":"etd"}},{"kind":"Field","name":{"kind":"Name","value":"atd"}},{"kind":"Field","name":{"kind":"Name","value":"etso"}},{"kind":"Field","name":{"kind":"Name","value":"eteo"}},{"kind":"Field","name":{"kind":"Name","value":"atso"}},{"kind":"Field","name":{"kind":"Name","value":"ateo"}},{"kind":"Field","name":{"kind":"Name","value":"etfm"}},{"kind":"Field","name":{"kind":"Name","value":"etlm"}},{"kind":"Field","name":{"kind":"Name","value":"atfm"}},{"kind":"Field","name":{"kind":"Name","value":"atlm"}},{"kind":"Field","name":{"kind":"Name","value":"atn"}},{"kind":"Field","name":{"kind":"Name","value":"dtn"}},{"kind":"Field","name":{"kind":"Name","value":"systemAta"}},{"kind":"Field","name":{"kind":"Name","value":"systemAtd"}},{"kind":"Field","name":{"kind":"Name","value":"systemEta"}},{"kind":"Field","name":{"kind":"Name","value":"systemEtd"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GeneralConnectingShipPortVisit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectingShipPortVisit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"bargeType"}},{"kind":"Field","name":{"kind":"Name","value":"mmsi"}},{"kind":"Field","name":{"kind":"Name","value":"eni"}},{"kind":"Field","name":{"kind":"Name","value":"planningNotes"}},{"kind":"Field","name":{"kind":"Name","value":"tanks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"positionNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"until"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdateFromAgentOn"}},{"kind":"Field","name":{"kind":"Name","value":"connectingShipBerthings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"window"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"from"}},{"kind":"Field","name":{"kind":"Name","value":"to"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationWithGroup"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationWithGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationGroup"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CompactLocation"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]} as unknown as DocumentNode<GetCargoQuery, GetCargoQueryVariables>;